import api from '@/services/api'

export const actions = {
    submitContact(context, data) {
        return new Promise((resolve) => {
            api('/session/token').then((response) => {
                api('/contact-us-form', data, 'POST', response.data)
                .then((data)=> {
                    resolve(context.commit('homepageData', data));
                })
                .catch(() => {
                    return
                });
            })
        });
    },
}